import React, {useEffect} from "react";
import {
  Button,
  ButtonContainer,
  ContentSection,
  Paragraph,
} from "@vwfs-bronson/bronson-react";
import { Output } from "../../Text";
import { Analytics } from '../../services/analytics';
import { setActualPage } from '../page.utils';
import { isVtiBOP } from '../../common/JourneyType';

const DocumentUploadSuccessPage = (props: DocumentUploadSuccessPageProps) => {
  const [counter, setCounter] = React.useState(30);
  const { redirectUrl, originSystem } = props;
  
  useEffect(() => {
    counter > 0
      ? setTimeout(() => setCounter(counter - 1), 1000)
      : window.location.href = redirectUrl;
  }, [counter, redirectUrl]);

  const pageName = 'Document upload success'

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
    [Analytics.keys.viewChange()]: pageName,
  }

  const trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: 'Contract Documents',
        [Analytics.keys.eventAction(0)]: 'Upload',
        [Analytics.keys.eventType(1)]: 'Product journey',
        [Analytics.keys.eventAction(1)]: 'End',
      }
      Analytics.setTrackingData({...defaultTrackingData, ...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  useEffect(() => {
    setActualPage(pageName)
    trackPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContentSection pageWrap pageWrapSize="medium">
      <header>
        <Paragraph className="u-text-center u-mb-xlarge">
          <i className="c-icon c-icon--xxlarge c-icon--[semantic-checkmark]"></i>
          <h3>{Output.resolve("pages.heyCar.documentUploadSuccess.title")}</h3>
        </Paragraph>
      </header>
      <Paragraph>
        {Output.resolve("pages.heyCar.documentUploadSuccess.success")}
      </Paragraph>
      <Paragraph>
        <strong>
          {Output.resolve("pages.heyCar.documentUploadSuccess.nextStepTitle")}
        </strong>
      </Paragraph>
      <Paragraph>
        {Output.resolve("pages.heyCar.documentUploadSuccess.nextStep")}
      </Paragraph>
      <Paragraph>
        {Output.resolve(isVtiBOP(originSystem)
          ? "pages.heyCar.documentUploadSuccess.vti.meanwhile"
          : "pages.heyCar.documentUploadSuccess.meanwhile")}
      </Paragraph>
      <ButtonContainer center className="u-mt-large">
        <Button
          className="appFixedButton"
          onClick={() => (window.location.href = redirectUrl)}
        >
          {Output.resolve(isVtiBOP(originSystem)
            ? "pages.heyCar.documentUploadSuccess.vti.buttonNext"
            : "pages.heyCar.documentUploadSuccess.buttonNext")}
        </Button>
      </ButtonContainer>
      <div className="u-text-center u-mt-small">
        {`${Output.resolve("pages.heyCar.documentUploadSuccess.countDownText1")} ${counter} ${Output.resolve("pages.heyCar.documentUploadSuccess.countDownText2")}`}
      </div>
    </ContentSection>
  );
};

type DocumentUploadSuccessPageProps = {
  redirectUrl: string;
  originSystem: string;
};

export { DocumentUploadSuccessPage };
